export class Player {
  public  name : string;
  public  school :string;
  public  email: string;
  public  town :string;
  public  device: string;
  public _id: string;
  public contestant: boolean;
}



// WEBPACK FOOTER //
// ./src/app/player.ts